import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'

export default function ErrorComponent ({ name, errorMessage }) {

  const errorMessages = {

    'required': (
      <FormattedMessage
        id='auth.signup.error.name_required'
        defaultMessage='{fieldname} is required.'
        values={{ fieldname: name }}
      />
    ),

    'email/pattern': (
      <FormattedMessage
        id='auth.signup.error.email_pattern'
        defaultMessage='Invalid email format'
        values={{ fieldname: name }}
      />
    ),

    'email/used': (
      <FormattedMessage
        id='auth.signup.error.email_used'
        defaultMessage='Sorry, that email is already in use.'
      />
    ),

    'name/pattern': (
      <FormattedMessage
        id='auth.signup.error.name_pattern'
        defaultMessage='{fieldname} can only contain characters, spaces, apostrophes, and periods.'
        values={{ fieldname: name }}
      />
    ),

    'password/pattern': (
      <FormattedMessage
        id='auth.signup.error.password_pattern'
        defaultMessage='Password must be at least 6 characters in length.'
      />
    ),

    'birthdate/ineligible': (
      <FormattedMessage
        id='auth.signup.error.age_ineligible'
        defaultMessage='Sorry, you are ineligible to participate at this time.'
      />
    ),

    'unknown': (
      <FormattedMessage
        id='auth.signup.error.unknown'
        defaultMessage='Unknown error with {fieldname}.'
        values={{ fieldname: name }}
      />
    ),

    'terms': (
      <FormattedMessage
        id='auth.signup.error.terms2'
        defaultMessage='You must accept the terms and conditions before registering as a new user.'
      />
    ),

  }

  return <span>{errorMessages[errorMessage] || errorMessage}</span>
}

ErrorComponent.propTypes = {
  name: PropTypes.string,
  errorMessage: PropTypes.string,
}
